module.exports = __webpack_public_path__ + "static/img/partner1.007ea67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/partner1.jpg
// module id = 68Zi
// module chunks = 1